import { render, staticRenderFns } from "./PollMultipleResults.vue?vue&type=template&id=3cc01634&scoped=true"
import script from "./PollMultipleResults.vue?vue&type=script&lang=js"
export * from "./PollMultipleResults.vue?vue&type=script&lang=js"
import style0 from "./PollMultipleResults.vue?vue&type=style&index=0&id=3cc01634&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc01634",
  null
  
)

export default component.exports